import { useEffect } from 'react';
import api from '../services/api';
import useAuthStore from '../store/authStore';
import useNavStore from '../store/navStore';
import useCustomStore from '../store/customStore';
import { buildScopeNav } from '../utils/buildScopeNav';

const PREFS_KEY = 'monquiz_dashboard_prefs';

function readPrefs() {
    try { return JSON.parse(localStorage.getItem(PREFS_KEY) || '{}'); }
    catch { return {}; }
}

// Repeuple le menu de thématiques (scope-nav) quand il est absent — typiquement
// après un rechargement (navStore est en mémoire → remis à null) sur une page qui
// ne monte PAS ScopeLanding (réglages compte, Activer un code, Guide…). Sans ça, le
// header thématiques disparaît jusqu'au prochain passage sur une page de scope.
//
// STRICTEMENT additif : ne déclenche que si scopeNav est null, et ne l'écrit que s'il
// est TOUJOURS null au moment de l'écriture (ScopeLanding, l'autorité, peut l'avoir
// posé entre-temps). Il ne peut donc jamais écraser/régresser une nav déjà correcte —
// au pire, en cas d'échec, la nav reste absente, soit l'état actuel.
export default function useEnsureScopeNav() {
    const user = useAuthStore((s) => s.user);
    const scopeNav = useNavStore((s) => s.scopeNav);
    const setScopeNav = useNavStore((s) => s.setScopeNav);
    const sharedThematiques = useCustomStore((s) => s.sharedThematiques);
    const fetchThematiques = useCustomStore((s) => s.fetchThematiques);

    useEffect(() => {
        if (!user || scopeNav) return;
        let cancelled = false;
        (async () => {
            try {
                // Les thématiques partagées peuvent ne pas être chargées après un reload.
                if (!sharedThematiques || sharedThematiques.length === 0) {
                    await fetchThematiques();
                }
                const { data: res } = await api.get('/scopes/list.php');
                if (cancelled) return;
                const prefs = readPrefs();
                const nav = buildScopeNav({
                    allScopes: res.data || [],
                    selectedScopes: prefs.selectedScopes || [],
                    scopeOrder: prefs.scopeOrder || [],
                    sharedThematiques: useCustomStore.getState().sharedThematiques || [],
                    hiddenSharedScopes: prefs.hiddenSharedScopes || [],
                    isCompte: true,
                    currentScope: null, // pages hors-scope → aucune pastille active
                });
                // Re-check au moment d'écrire : ScopeLanding a pu poser la nav entre-temps.
                if (nav && !cancelled && !useNavStore.getState().scopeNav) {
                    setScopeNav(nav);
                }
            } catch { /* silencieux : au pire la nav reste absente (état actuel) */ }
        })();
        return () => { cancelled = true; };
        // Volontairement limité à (user, scopeNav) : on ne relance que sur login ou
        // perte de nav. Les autres valeurs sont relues via getState au moment utile.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, scopeNav]);
}
